import { cn } from '@bem-react/classname';

export const cnLayoutPage = cn('LayoutPage');
